import _ from 'underscore';
import Backbone from 'backbone';
import Insight from 'models/insight/Insight';

var Insights = Backbone.Collection.extend({
    model: Insight,

    backend: 'insights',

    url: function() {
        return '/gcs-insights/api/feature/history';
    },

    parse: function(data) {
        // removing empty insights and insights without featureId or createdDateUTC (both are necessary for the details call)
        data = _.filter(data, function(insight) {
            return !_.isEmpty(insight) || insight.featureId || insight.createdDateUTC;
        });

        return data;
    },

    getUnreadInsights: function() {
        return _.filter(this.models, function(insight) {
            return insight.get('status') === Insight.STATUS.UNREAD;
        });
    }
});

export default Insights;
